// Translations
export const T = {
  en_GB: {
    label: "Advisor override",
    off: "Off",
    allowed: "Allowed",
    noteRequired: "Allowed, note required",
    description:
      "Lets advisors override this fee for one advice session, e.g. for negotiated pricing. The client sees the catalogue value struck through.",
  },
  nb_NO: {
    label: "Rådgivers overstyring",
    off: "Av",
    allowed: "Tillatt",
    noteRequired: "Tillatt, krever begrunnelse",
    description:
      "Lar rådgivere overstyre denne kostnaden i én rådgivning, f.eks. ved fremforhandlet pris. Kunden ser katalogverdien overstreket.",
  },
} as const;
